/**
 * 主應用程式
 * 參考 towconnect-web 的 App.tsx 路由架構
 */

import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { LiffProvider } from '@/contexts/LiffContext'
import ProtectedRoute from '@/components/ProtectedRoute'
import EntryPage from '@/pages/EntryPage'
import HomePage from '@/pages/Home/HomePage'
import BindingPage from '@/pages/BindingPage'
import VehicleSelectionPage from '@/pages/VehicleSelectionPage'
import VehicleConfirmPage from '@/pages/VehicleConfirmPage'
import TaskBrowsePage from '@/pages/TaskBrowsePage'
import VehicleHandoverPage from '@/pages/VehicleHandoverPage'
import DailyReportPage from '@/pages/DailyReportPage'
import MissionAmendmentPage from '@/pages/MissionAmendmentPage'
// 外車（同業）接單：同一個 LIFF、不同入口、獨立驗證（openspec add-external-driver-grab）
import ExtGuard from '@/ext/ExtGuard'
import ExtBatchPage from '@/ext/ExtBatchPage'
import ExtBindPage from '@/ext/ExtBindPage'
import ExtProfilePage from '@/ext/ExtProfilePage'
import ExtHistoryPage from '@/ext/ExtHistoryPage'

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <LiffProvider>
        <Routes>
          {/* 應用入口頁面 - LINE Developers Console Endpoint URL 指向這裡 */}
          <Route path="/" element={<EntryPage />} />

          {/* 司機綁定頁面 */}
          <Route
            path="/binding"
            element={
              <ProtectedRoute>
                <BindingPage />
              </ProtectedRoute>
            }
          />

          {/* 首頁（受保護） */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />

          {/* 車輛選擇頁面 */}
          <Route
            path="/vehicle-selection"
            element={
              <ProtectedRoute>
                <VehicleSelectionPage />
              </ProtectedRoute>
            }
          />

          {/* 車輛資訊確認頁面 */}
          <Route
            path="/vehicle-confirm"
            element={
              <ProtectedRoute>
                <VehicleConfirmPage />
              </ProtectedRoute>
            }
          />

          {/* 任務瀏覽頁面 */}
          <Route
            path="/tasks"
            element={
              <ProtectedRoute>
                <TaskBrowsePage />
              </ProtectedRoute>
            }
          />

          {/* 車輛交班頁面 */}
          <Route
            path="/handover"
            element={
              <ProtectedRoute>
                <VehicleHandoverPage />
              </ProtectedRoute>
            }
          />

          {/* 司機日報表頁面 */}
          <Route
            path="/daily-report"
            element={
              <ProtectedRoute>
                <DailyReportPage />
              </ProtectedRoute>
            }
          />

          {/* 任務補登頁面（FUNC026） */}
          <Route
            path="/mission-amendment"
            element={
              <ProtectedRoute>
                <MissionAmendmentPage />
              </ProtectedRoute>
            }
          />

          {/* 未匹配路由 - 導向入口頁面 */}
          {/* 外車路由：不包 ProtectedRoute（它會導回 / 會員入口），改用 ExtGuard 只要求 LIFF 已登入 */}
          <Route path="/ext/batch/:token" element={<ExtGuard><ExtBatchPage /></ExtGuard>} />
          <Route path="/ext/bind" element={<ExtGuard><ExtBindPage /></ExtGuard>} />
          <Route path="/ext/me" element={<ExtGuard><ExtProfilePage /></ExtGuard>} />
          <Route path="/ext/history" element={<ExtGuard><ExtHistoryPage /></ExtGuard>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </LiffProvider>
    </BrowserRouter>
  )
}

export default App
